/**
 * DashboardStats Entity
 * Represents dashboard statistics for a specific role
 */
export interface DashboardStatsProps {
  stat1: { label: string; value: string; trend: string; icon: string; color: string };
  stat2: { label: string; value: string; trend: string; icon: string; color: string };
  stat3: { label: string; value: string; trend: string; icon: string; color: string };
}

export class DashboardStats {
  private readonly props: DashboardStatsProps;

  constructor(props: DashboardStatsProps) {
    this.props = props;
  }

  get stat1() {
    return this.props.stat1;
  }

  get stat2() {
    return this.props.stat2;
  }

  get stat3() {
    return this.props.stat3;
  }

  toPlainObject(): DashboardStatsProps {
    return { ...this.props };
  }
}
